import { useEffect } from 'react'
import { User } from 'types/user'
import { cleanObject } from 'utils'
import { useHttp } from './http'
import { useAsync } from './use-async'

export const useUsers = (param?: Partial<User>) => {
  const client = useHttp()
  const { run, ...result } = useAsync<User[]>()

  useEffect(() => {
    run(client(`users`, { data: cleanObject(param || {}) }))
  }, [param, run, client])

  return result
}
